import { useLang } from '@/i18n';
import EcoSpace from 'eco-design/base/eco-space';
export default function Comp() {
    const { t } = useLang('theProduct.SectionA3');

    return (
        <>
            <EcoSpace />
            <img src="https://websiteoss.ecoflow.com/upload/image/1741258724987/image%205155625.jpg" className="demo-img-full" />
        </>
    );
}
